<template>
  <a-dropdown v-if="currentUser && currentUser.name" :overlay-style="{ minWidth: '140px' }">
    <span class="account-avatar">
      <a-avatar
        alt="avatar"
        :src="currentUser.avatar"
        class="antd-pro-global-header-index-avatar"
        >{{ currentUser.name }}</a-avatar
      >
      <span style="color: #1d2129; padding: 0 8px">{{ currentUser.name }}</span>
      <a-icon type="caret-down" />
      <!-- <a-icon type="caret-up" /> -->
    </span>
    <template v-if="menu" #overlay>
      <a-menu :selected-keys="[]">
        <a-menu-item v-if="center" key="center" @click="handleToCenter">
          {{ $t('app.account.center') }}
        </a-menu-item>
        <a-menu-item v-if="help" key="help" @click="handleToHelp">
          <!-- <a href="#"
            target="_blank">{{ $t("app.account.help") }}
          </a> -->
          {{ $t('app.account.help') }}
        </a-menu-item>
        <a-sub-menu
          v-if="showChangeLanguage"
          key="lang"
          :title="$t('app.account.lang')"
          @click="SwitchLang"
        >
          <a-menu-item key="zh-CN">
            <span role="img" aria-label="简体中文">简体中文</span>
            <a-icon v-show="'zh-CN' === curLang" type="check" class="checked" />
          </a-menu-item>
          <a-menu-item key="en-US">
            <span role="img" aria-label="English(US)">English</span>
            <a-icon v-show="'en-US' === curLang" type="check" class="checked" />
          </a-menu-item>
        </a-sub-menu>
        <!-- <a-menu-item v-if="settings" key="settings" @click="handleToSettings">
          {{ $t('app.account.settings') }}
        </a-menu-item>
        <a-menu-divider /> -->
        <a-menu-item v-if="logout" key="logout" @click="handleLogout">
          {{ $t('app.account.logout') }}
        </a-menu-item>
      </a-menu>
    </template>
  </a-dropdown>
  <span v-else>
    <a-spin size="small" :style="{ marginLeft: 8, marginRight: 8 }" />
  </span>
</template>

<script>
import axios from 'axios';
import { goSSO } from '@/utils';

export default {
  name: 'AvatarDropdown',
  components: {},
  props: {
    currentUser: {
      type: Object,
      default: () => null,
    },
    menu: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      // TODO: 各项目按照需要设置可见项
      center: false,
      help: false,
      settings: false,
      logout: true,
    };
  },
  computed: {
    curLang() {
      return this.$store.state.system.app.lang;
    },
    showChangeLanguage() {
      return this.$store.state.system.app.showChangeLanguage;
    },
  },
  methods: {
    handleToCenter() {
      this.$router.push({ path: '/account/center' });
    },
    handleToHelp() {},
    SwitchLang(row) {
      // console.log(row)
      const { key } = row;
      axios.get(`${process.env.VUE_APP_API_BASE_URL_AUTHORITY}/i18n/changeLanguage?lang=${key}`, {
        withCredentials: true,
      });
      this.$store.dispatch('system/app/setLang', key);
      this.$notification.info({
        message: this.$t('app.lang.langSwitch'),
        description: this.$t('app.lang.langMessage'),
        top: '48px',
      });
    },
    handleToSettings() {
      this.$router.push({ path: '/account/settings' });
    },
    handleLogout() {
      const onOk = () => {
        this.$store.dispatch('system/user/Logout').then(() => {
          // this.$router.push({ path: '/login' });
          goSSO();
        });
      };
      window.antd.Modal.confirm({
        title: this.$t('app.account.dialog.title'),
        content: this.$t('app.account.dialog.content'),
        onOk,
      });
    },
  },
};
</script>

<style lang="less" scoped>
.account-avatar {
  color: #8c96a3 !important;
}
.checked {
  color: @primary-color;
  float: right;
  margin: 4px 0 0 16px;
}
</style>
